import { useState } from "react";
import { FaBell, FaBullhorn, FaEnvelope, FaTimes } from "react-icons/fa";

interface Props {
    isOpen: boolean;
    guestName: string;
    headline?: string;
    onClose: () => void;
    onSubmit: (data: {
        message: string;
        type: "notification" | "banner" | "message";
    }) => void;
}

export default function NotifyGuestModal({
    isOpen,
    guestName,
    headline,
    onClose,
    onSubmit,
}: Props) {
    const [message, setMessage] = useState("");
    const [type, setType] = useState<"notification" | "banner" | "message">(
        "notification"
    );

    if (!isOpen) return null;

    const handleSubmit = () => {
        // if (!message.trim()) return;

        onSubmit({ message, type });
        setMessage("");
        setType("notification");
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="w-full max-w-md rounded-2xl bg-white shadow-xl p-6 relative animate-fadeIn">

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                >
                    {FaTimes({ size: 18 })}
                </button>

                {/* Title */}
                <h2 className="text-xl font-semibold mb-1">
                    Send Message to {guestName}
                </h2>
                <p className="text-sm text-gray-500 mb-5">
                    Choose how {guestName} should receive this message
                </p>

                {/* Type Selection */}
                <div className="flex flex-wrap gap-3 mb-5">
                    <button
                        onClick={() => {
                            setType("notification");
                              setMessage("");
                        }}
                        className={`flex-1 min-w-[100px] flex items-center justify-center gap-2 p-3 rounded-xl border transition ${type === "notification"
                            ? "bg-blue-50 border-blue-500 text-blue-600"
                            : "border-gray-200 text-gray-500 hover:bg-gray-50"
                            }`}
                    >
                        {FaBell({})}
                        <span className="truncate">Notification</span>
                    </button>

                    <button
                        onClick={() => {
                            setType("banner");
                            setMessage(headline ?? "");

                        }}
                        className={`flex-1 min-w-[100px] flex items-center justify-center gap-2 p-3 rounded-xl border transition ${type === "banner"
                            ? "bg-yellow-50 border-yellow-500 text-yellow-600"
                            : "border-gray-200 text-gray-500 hover:bg-gray-50"
                            }`}
                    >
                        {FaBullhorn({})}
                        <span className="truncate">Banner</span>
                    </button>

                    <button
                        onClick={() => {
                            setType("message");
                            setMessage("");
                        }}
                        className={`flex-1 min-w-[100px] flex items-center justify-center gap-2 p-3 rounded-xl border transition ${type === "message"
                            ? "bg-green-50 border-green-500 text-green-600"
                            : "border-gray-200 text-gray-500 hover:bg-gray-50"
                            }`}
                    >
                        {FaEnvelope({})}
                        <span className="truncate">Message</span>
                    </button>
                </div>

                {/* Message Input */}
                <textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder={
                        type === "banner"
                            ? "Enter headline (e.g. Your stay expired today. Consider extending your booking!)"
                            : type === "notification"
                                ? "Enter notification message..."
                                : "Enter normal message..."
                    }
                    className="w-full h-28 p-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
                />

                {/* Actions */}
                <div className="flex justify-end gap-3 mt-5 flex-wrap">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg text-gray-500 hover:bg-gray-100"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={() => {
                            onClose();
                            handleSubmit();
                        }}
                        className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition"
                    >
                        Send
                    </button>
                </div>
            </div>
        </div>
    );
}